export default {
  links: {},
  sources: {},
  contentHtml: `
    <h2>Введение</h2>
    <div class="content-stub" contenteditable="false">Добавьте содержимое</div>
    <h2>Материалы и методы</h2>
    <div class="content-stub" contenteditable="false">Добавьте содержимое</div>
    <h2>Результаты</h2>
    <div class="content-stub" contenteditable="false">Добавьте содержимое</div>
    <h2>Заключение</h2>
    <div class="content-stub" contenteditable="false">Добавьте содержимое</div>
  `,
  docs: [],
  docName: null,
  docSaved: false,

  profileName: null,
  isAuthorized: false,
  authToken: null,
  userId: null
}



// WEBPACK FOOTER //
// ./src/vuex/state.js